<div class="feed">
  <h3 class="feed__title">Activity Feed</h3>

  <div class="feed-empty" *ngIf="entries.length === 0; else feedList">
    No scans yet.
  </div>

  <ng-template #feedList>
    <ul class="feed__list">
      <li *ngFor="let e of entries; trackBy: trackByEntry" class="feed-row">
        <span class="feed-row__check">✓</span>
        <div class="feed-row__body">
          <div class="feed-row__name">
            {{ e.med.medicationName }}
            <span *ngIf="e.med.isSubstitute" class="feed-row__alt">ALT</span>
          </div>
          <div class="feed-row__meta">→ Box #{{ e.basket.basketNumber }} · {{ e.basket.patientName }}</div>
        </div>
        <span class="feed-row__time">{{ e.pickedAt | date:'HH:mm' }}</span>
      </li>
    </ul>
  </ng-template>
</div>
